import { axios } from './index'

export default {
    index(params) {
        return axios
          .get('all-staffs-members', {
            params,
          })
          .then(response => Promise.resolve(response))
          .catch(error => Promise.reject(error))
      },
}

